export const messages = {
  en: {
    addWork: {
      title: 'Create Work Order',
      workName: 'Title',
      workNamePlaceholder: 'Required, please enter title',
      workType: 'Work Order Type',
      workTypePlaceholder: 'Required, please select work order type',
      processor: 'Processor',
      cc: 'CC',
      choose: 'Choose',
      workCycle: 'Work Order Flag',
      workCyclePlaceholder: 'Required, please select work order flag',
      onceWork: 'One-time Work Order',
      periodWork: 'Periodic Work Order',
      attachment: 'Attachment',
      startTime: 'Start Time',
      startTimePlaceholder: 'Required, please enter start time',
      endTime: 'End Time',
      endTimePlaceholder: 'Required, please enter end time',
      period: 'Period',
      periodPlaceholder: 'Required, please select task period',
      monthDay: 'Month/Day',
      week: 'By Week',
      hours: 'Work Order',
      hoursPlaceholder: 'Required, please enter hours',
      hoursUnit: 'hours to complete',
      month: 'Month',
      monthUnit: 'Month',
      day: 'Day',
      dayUnit: 'Day',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      content: 'Content',
      contentPlaceholder: 'Required, please enter content',
      addContent: 'Add',
      deleteContent: 'Delete'
    },
    uploadFile: {
      upload: 'Upload Attachment',
      sizeLimit: 'File size cannot exceed 20MB',
      success: 'File uploaded successfully',
      failed: 'File upload failed'
    },
  },
  zh: {
    addWork: {
      title: '发起工作单',
      workName: '标题',
      workNamePlaceholder: '必填，请填写标题',
      workPlan: '明日工作计划',
      workPlanPlaceholder: '必填，请填写明日工作计划',
      problemsEncountered: '遇到的问题',
      problemsEncounteredPlaceholder: '必填，请填写遇到的问题',
      workType: '任务类型',
      workTypePlaceholder: '必填，请选择任务类型',
      processor: '处理人',
      cc: '抄送人',
      choose: '选择',
      workCycle: '任务标识',
      workCyclePlaceholder: '必填，请选择任务标识',
      onceWork: '一次性工单',
      periodWork: '周期性工单',
      attachment: '附件',
      startTime: '开始时间',
      startTimePlaceholder: '必填，请填写开始时间',
      endTime: '结束时间',
      endTimePlaceholder: '必填，请填写结束时间',
      period: '周期',
      periodPlaceholder: '必填，请选择任务周期',
      monthDay: '月/天',
      week: '按周',
      hours: '工作单',
      hoursPlaceholder: '必填，请输入小时数',
      hoursUnit: '小时内完成',
      month: '月',
      monthUnit: '月',
      day: '日',
      dayUnit: '日',
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六',
      sunday: '星期日',
      content: '内容',
      contentPlaceholder: '必填，请输入内容',
      addContent: '添加',
      deleteContent: '删除'
    },
    uploadFile: {
      upload: '上传附件',
      sizeLimit: '文件大小不能超过20MB',
      success: '文件上传成功',
      failed: '文件上传失败'
    },
  }
}